import { DashboardShell } from "@/components/dashboard-shell"
import { LeadsOverTime } from "@/components/dashboard/leads-over-time"
import { MetricCards } from "@/components/dashboard/metric-cards"
import { LeadFunnel } from "@/components/leads/lead-funnel"
import { LeadsByRegion } from "@/components/leads/leads-by-region"
import { RecentLeads } from "@/components/leads/recent-leads"
import { leadsMetrics } from "@/lib/leads-data"
import { createFileRoute } from "@tanstack/react-router";
import {
  RouteLoading,
  LeadsLoadingSkeleton,
} from "@/components/route-loading";

export const Route = createFileRoute("/leads")({
  component: LeadsPage,
  head: () => ({ meta: [{ title: "Leads" }] }),
  pendingComponent: LeadsPending,
});

function LeadsPage() {
  return (
    <DashboardShell>
      <MetricCards metrics={leadsMetrics} />
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <LeadsOverTime />
        <LeadFunnel />
      </div>
      <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-[3fr_2fr]">
        <RecentLeads />
        <LeadsByRegion />
      </div>
    </DashboardShell>
  )
}

// Shown while this route's chunk (and the ReUI components in it)
// downloads. Was src/app/leads/loading.tsx.
function LeadsPending() {
  return (
    <RouteLoading>
      <LeadsLoadingSkeleton />
    </RouteLoading>
  );
}
